<script lang="ts" setup>
import { faTrash } from '@fortawesome/pro-regular-svg-icons'
import GPromiseButton from './GPromiseButton.vue'
import type { ButtonSize } from './GButton.vue'

const { size = 'xsmall' } = defineProps<{ size?: ButtonSize }>()

</script>

<template>
  <GPromiseButton
    danger
    label="Delete"
    :icon="faTrash"
    iconButton
    :size="size"
  />
</template>
